import { addClientTagApi, removeClientTagApi } from '../api/tag';

const eventOn = emitter => {
  emitter.promiseOn('addClientTag', params => {
    return addClientTagApi(params);
  });

  emitter.promiseOn('removeClientTag', params => {
    return removeClientTagApi(params);
  });
};

export default eventOn;
